import BottomSheet from "@gorhom/bottom-sheet";
import React, { useEffect, useRef } from "react";
import { Platform, Pressable, StyleSheet, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import CommentModal from "./comment";
import { AppDispatch, RootState } from "../../redux/store";
import { clearModal } from "../../redux/slices/modalSlice";

const Modal = () => {
  const modalState = useSelector((state: RootState) => state.modal);
  const bottomSheetRef = useRef<BottomSheet>(null);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    if (modalState.open && bottomSheetRef.current) {
      bottomSheetRef.current.expand();
    }
  }, [modalState]);

  const renderContent = () => {
    switch (modalState.modalType) {
      case 0:
        if (modalState.data) {
          return (
            <CommentModal
              post={modalState.data}
              onCommentSend={modalState.onCommentSend}
            />
          );
        }
        return <></>;
      default:
        return <></>;
    }
  };
  const onClose = () => {
    dispatch(clearModal());
  };

  if (Platform.OS === "web") {
    if (!modalState.open) return null;

    return (
      <View style={styles.webOverlay}>
        <Pressable style={styles.webBackdrop} onPress={onClose} />
        <View style={styles.webSheet}>
          <View style={styles.webHandle} />
          {renderContent()}
        </View>
      </View>
    );
  }

  return (
    <BottomSheet
      ref={bottomSheetRef}
      snapPoints={["50%"]}
      index={-1}
      onClose={onClose}
      handleHeight={40}
      enablePanDownToClose
    >
      {renderContent()}
    </BottomSheet>
  );
};

export default Modal;

const styles = StyleSheet.create({
  webOverlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 1000,
    justifyContent: "flex-end",
  },
  webBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  webSheet: {
    height: "50%",
    backgroundColor: "white",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: "hidden",
  },
  webHandle: {
    alignSelf: "center",
    width: 42,
    height: 4,
    borderRadius: 2,
    backgroundColor: "#ccc",
    marginVertical: 10,
  },
});
